import {type GetterTree} from 'vuex';

const getters: GetterTree<LightBoxState, RootState> = {
    open(state)
    {
        return state.images.length > 0;
    },

    images(state)
    {
        return state.images;
    },

    current(state)
    {
        return state.current;
    },

    currentImage(state)
    {
        return state.images[state.current - 1];
    }
};

export default getters;